import {
  JsonElementSerializer_getInstanceiquifkyyjet4 as JsonElementSerializer_getInstance,
  JsonPrimitiveSerializer_getInstance3aiuqg95nb72f as JsonPrimitiveSerializer_getInstance,
  JsonObjectSerializer_getInstance3o7o9v4y0v2ri as JsonObjectSerializer_getInstance,
  JsonArraySerializer_getInstance1f8qk7xwnxq6f as JsonArraySerializer_getInstance,
  JsonNullSerializer_getInstanceqqm0uzwzj062 as JsonNullSerializer_getInstance,
} from './JsonElementSerializers.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import {
  printQuotedmgc3s3pgfors as printQuoted,
  toBooleanStrictOrNull2hf9surgqf5vr as toBooleanStrictOrNull,
} from './internal/StringOps.mjs';
import { _Char___init__impl__6a9atx1csff5kwtduxl as _Char___init__impl__6a9atx } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  toString1pkumu07cwy4m as toString,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { joinToString1cxrrlmo0chqs as joinToString } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  KtMap140uvy3s5zad8 as KtMap,
  KtList3hktaavzmj137 as KtList,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { SerializerFactory1qv9hivitncuv as SerializerFactory } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { StringJsonLexervr9dj3kex5li as StringJsonLexer } from './internal/StringJsonLexer.mjs';
import { toDouble1kn912gjoizjp as toDouble } from '../../../../kotlin-kotlin-stdlib/kotlin/text/numberConversions.mjs';
import { StringCompanionObject_instance3sox3h548pjra as StringCompanionObject_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/js/internal/primitiveCompanionObjects.mjs';
import { serializer1x79l67jvwntn as serializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { InlinePrimitiveDescriptor3i6ccn1a4fw94 as InlinePrimitiveDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/InlineClassDescriptor.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function get_jsonUnquotedLiteralDescriptor() {
  _init_properties_JsonElement_kt__7cbdc2();
  return jsonUnquotedLiteralDescriptor;
}
var jsonUnquotedLiteralDescriptor;
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      n29() {
        return JsonElementSerializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var JsonElementClass;
function JsonElement() {
  if (JsonElementClass === VOID) {
    class $ {}
    initMetadataForClass($, 'JsonElement', VOID, VOID, VOID, VOID, VOID, {0: JsonElementSerializer_getInstance});
    JsonElementClass = $;
  }
  return JsonElementClass;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  return Companion_instance_0;
}
var JsonPrimitiveClass;
function JsonPrimitive() {
  if (JsonPrimitiveClass === VOID) {
    class $ extends JsonElement() {
      toString() {
        return this.i2o();
      }
    }
    initMetadataForClass($, 'JsonPrimitive', VOID, VOID, VOID, VOID, VOID, {0: JsonPrimitiveSerializer_getInstance});
    JsonPrimitiveClass = $;
  }
  return JsonPrimitiveClass;
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_1;
function Companion_getInstance_1() {
  return Companion_instance_1;
}
function JsonObject$toString$lambda(_destruct__k2r9zo) {
  // Inline function 'kotlin.collections.component1' call
  var k = _destruct__k2r9zo.r3();
  // Inline function 'kotlin.collections.component2' call
  var v = _destruct__k2r9zo.s3();
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder().q1();
  printQuoted(this_0, k);
  this_0.t1(_Char___init__impl__6a9atx(58));
  this_0.x1(v);
  return this_0.toString();
}
var JsonObjectClass;
function JsonObject() {
  if (JsonObjectClass === VOID) {
    class $ extends JsonElement() {
      constructor(content) {
        super();
        this.j2o_1 = content;
      }
      equals(other) {
        return equals(this.j2o_1, other);
      }
      hashCode() {
        return hashCode(this.j2o_1);
      }
      toString() {
        var tmp = this.j2o_1.q3();
        return joinToString(tmp, ',', '{', '}', VOID, VOID, JsonObject$toString$lambda);
      }
      s1() {
        return this.j2o_1.s1();
      }
      k2o(key) {
        return this.j2o_1.x4(key);
      }
      x4(key) {
        if (!(!(key == null) ? typeof key === 'string' : false))
          return false;
        return this.k2o((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
      }
      l2o(key) {
        return this.j2o_1.z4(key);
      }
      z4(key) {
        if (!(!(key == null) ? typeof key === 'string' : false))
          return null;
        return this.l2o((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
      }
      v2() {
        return this.j2o_1.v2();
      }
      a5() {
        return this.j2o_1.a5();
      }
      b5() {
        return this.j2o_1.b5();
      }
      q3() {
        return this.j2o_1.q3();
      }
    }
    initMetadataForClass($, 'JsonObject', VOID, VOID, [JsonElement(), KtMap()], VOID, VOID, {0: JsonObjectSerializer_getInstance});
    JsonObjectClass = $;
  }
  return JsonObjectClass;
}
var CompanionClass_2;
function Companion_2() {
  if (CompanionClass_2 === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass_2 = $;
  }
  return CompanionClass_2;
}
var Companion_instance_2;
function Companion_getInstance_2() {
  return Companion_instance_2;
}
var JsonArrayClass;
function JsonArray() {
  if (JsonArrayClass === VOID) {
    class $ extends JsonElement() {
      constructor(content) {
        super();
        this.m2o_1 = content;
      }
      equals(other) {
        return equals(this.m2o_1, other);
      }
      hashCode() {
        return hashCode(this.m2o_1);
      }
      toString() {
        return joinToString(this.m2o_1, ',', '[', ']');
      }
      s1() {
        return this.m2o_1.s1();
      }
      n2o(element) {
        return this.m2o_1.y2(element);
      }
      y2(element) {
        if (!(element instanceof JsonElement()))
          return false;
        return this.n2o(element instanceof JsonElement() ? element : THROW_CCE());
      }
      u1() {
        return this.m2o_1.u1();
      }
      o2o(elements) {
        return this.m2o_1.v4(elements);
      }
      v4(elements) {
        return this.o2o(elements);
      }
      w2(index) {
        return this.m2o_1.w2(index);
      }
      p2o(element) {
        return this.m2o_1.w4(element);
      }
      w4(element) {
        if (!(element instanceof JsonElement()))
          return -1;
        return this.p2o(element instanceof JsonElement() ? element : THROW_CCE());
      }
      a3(index) {
        return this.m2o_1.a3(index);
      }
      g3(fromIndex, toIndex) {
        return this.m2o_1.g3(fromIndex, toIndex);
      }
      v2() {
        return this.m2o_1.v2();
      }
    }
    initMetadataForClass($, 'JsonArray', VOID, VOID, [JsonElement(), KtList()], VOID, VOID, {0: JsonArraySerializer_getInstance});
    JsonArrayClass = $;
  }
  return JsonArrayClass;
}
var JsonNullClass;
function JsonNull() {
  if (JsonNullClass === VOID) {
    class $ extends JsonPrimitive() {
      constructor() {
        JsonNull_instance = null;
        super();
        JsonNull_instance = this;
        this.q2o_1 = 'null';
      }
      i2o() {
        return this.q2o_1;
      }
      n29() {
        return JsonNullSerializer_getInstance();
      }
      k20(typeParamsSerializers) {
        return this.n29();
      }
    }
    initMetadataForObject($, 'JsonNull', VOID, VOID, [JsonPrimitive(), SerializerFactory()], VOID, VOID, {0: JsonNullSerializer_getInstance});
    JsonNullClass = $;
  }
  return JsonNullClass;
}
var JsonNull_instance;
function JsonNull_getInstance() {
  if (JsonNull_instance === VOID)
    new (JsonNull())();
  return JsonNull_instance;
}
var JsonLiteralClass;
function JsonLiteral() {
  if (JsonLiteralClass === VOID) {
    class $ extends JsonPrimitive() {
      constructor(body, isString, coerceToInlineType) {
        coerceToInlineType = coerceToInlineType === VOID ? null : coerceToInlineType;
        super();
        this.r2o_1 = isString;
        this.s2o_1 = coerceToInlineType;
        this.t2o_1 = toString(body);
        if (!(this.s2o_1 == null)) {
          // Inline function 'kotlin.require' call
          // Inline function 'kotlin.require' call
          if (!this.s2o_1.u1p()) {
            var message = 'Failed requirement.';
            throw IllegalArgumentException().s2(toString(message));
          }
        }
      }
      i2o() {
        return this.t2o_1;
      }
      toString() {
        var tmp;
        if (this.r2o_1) {
          // Inline function 'kotlin.text.buildString' call
          // Inline function 'kotlin.apply' call
          var this_0 = StringBuilder().q1();
          printQuoted(this_0, this.t2o_1);
          tmp = this_0.toString();
        } else {
          tmp = this.t2o_1;
        }
        return tmp;
      }
      equals(other) {
        if (this === other)
          return true;
        if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
          return false;
        if (!(other instanceof JsonLiteral()))
          THROW_CCE();
        if (!(this.r2o_1 === other.r2o_1))
          return false;
        if (!(this.t2o_1 === other.t2o_1))
          return false;
        return true;
      }
      hashCode() {
        var result = getBooleanHashCode(this.r2o_1);
        result = imul(31, result) + getStringHashCode(this.t2o_1) | 0;
        return result;
      }
    }
    initMetadataForClass($, 'JsonLiteral');
    JsonLiteralClass = $;
  }
  return JsonLiteralClass;
}
function get_jsonPrimitive(_this__u8e3s4) {
  _init_properties_JsonElement_kt__7cbdc2();
  var tmp0_elvis_lhs = _this__u8e3s4 instanceof JsonPrimitive() ? _this__u8e3s4 : null;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    error(_this__u8e3s4, 'JsonPrimitive');
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function get_contentOrNull(_this__u8e3s4) {
  _init_properties_JsonElement_kt__7cbdc2();
  var tmp;
  if (_this__u8e3s4 instanceof JsonNull()) {
    tmp = null;
  } else {
    tmp = _this__u8e3s4.i2o();
  }
  return tmp;
}
function get_booleanOrNull(_this__u8e3s4) {
  _init_properties_JsonElement_kt__7cbdc2();
  return toBooleanStrictOrNull(_this__u8e3s4.i2o());
}
function parseLongImpl(_this__u8e3s4) {
  _init_properties_JsonElement_kt__7cbdc2();
  return (new (StringJsonLexer())(_this__u8e3s4.i2o())).u2o();
}
function get_float(_this__u8e3s4) {
  _init_properties_JsonElement_kt__7cbdc2();
  // Inline function 'kotlin.text.toFloat' call
  var this_0 = _this__u8e3s4.i2o();
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return toDouble(this_0);
}
function get_double(_this__u8e3s4) {
  _init_properties_JsonElement_kt__7cbdc2();
  return toDouble(_this__u8e3s4.i2o());
}
function JsonPrimitive_0(value) {
  _init_properties_JsonElement_kt__7cbdc2();
  if (value == null)
    return JsonNull_getInstance();
  return new (JsonLiteral())(value, true);
}
function JsonPrimitive_1(value) {
  _init_properties_JsonElement_kt__7cbdc2();
  if (value == null)
    return JsonNull_getInstance();
  return new (JsonLiteral())(value, false);
}
function JsonPrimitive_2(value) {
  _init_properties_JsonElement_kt__7cbdc2();
  if (value == null)
    return JsonNull_getInstance();
  return new (JsonLiteral())(value, false);
}
function error(_this__u8e3s4, element) {
  _init_properties_JsonElement_kt__7cbdc2();
  throw IllegalArgumentException().s2('Element ' + toString(getKClassFromExpression(_this__u8e3s4)) + ' is not a ' + element);
}
var properties_initialized_JsonElement_kt_abxy8s;
function _init_properties_JsonElement_kt__7cbdc2() {
  if (!properties_initialized_JsonElement_kt_abxy8s) {
    properties_initialized_JsonElement_kt_abxy8s = true;
    jsonUnquotedLiteralDescriptor = InlinePrimitiveDescriptor('kotlinx.serialization.json.JsonUnquotedLiteral', serializer(StringCompanionObject_instance));
  }
}
//region block: init
Companion_instance = new (Companion())();
Companion_instance_0 = new (Companion_0())();
Companion_instance_1 = new (Companion_1())();
Companion_instance_2 = new (Companion_2())();
//endregion
//region block: exports
export {
  Companion_instance as Companion_instance2ikyq4bbz6wqt,
  JsonNull_getInstance as JsonNull_getInstance3cean630pgfyb,
  JsonArray as JsonArray2urf8ey7u44sd,
  JsonElement as JsonElementf07o4p6p57al,
  JsonLiteral as JsonLiteral1u57id0qmqut7,
  JsonNull as JsonNull2liwjj96vm0w2,
  JsonObject as JsonObjectee06ihoeeiqj,
  JsonPrimitive_0 as JsonPrimitiveolttw629wj53,
  JsonPrimitive_1 as JsonPrimitive2fp8648nd60dn,
  JsonPrimitive_2 as JsonPrimitive1xkjzc5d7ihuv,
  JsonPrimitive as JsonPrimitive3ttzjh2ft5dnx,
  get_booleanOrNull as get_booleanOrNull376axlcpdhkmo,
  get_contentOrNull as get_contentOrNull35s97cgi8z9eo,
  get_double as get_double1785hcxaminy4,
  get_float as get_float1xtaobzj8js8m,
  get_jsonPrimitive as get_jsonPrimitivez17tyd5rw1ql,
  get_jsonUnquotedLiteralDescriptor as get_jsonUnquotedLiteralDescriptors6ipxyp7dsvf,
  parseLongImpl as parseLongImpl2gkj8byk018b9,
};
//endregion

//# sourceMappingURL=JsonElement.mjs.map
